
import { Create, SimpleForm, TextInput, DateInput, NumberInput } from 'react-admin';

export const Tbl_sportCreate = props => (
    <Create {...props}>
        <SimpleForm>
            <TextInput source="nome" />
            <TextInput source="note" />
            <NumberInput source="flVisibile" />
            <NumberInput source="flAttivo" />
            <NumberInput source="flAnnullato" />
            <NumberInput source="ordinamento" />
            <DateInput source="createdAt" />
            <DateInput source="updatedAt" />
        </SimpleForm>
    </Create>
);
            